/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const filter = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M6.333 13.333h8m-8 0a1.667 1.667 0 1 1-3.333 0m3.333 0a1.667 1.667 0 0 0-3.333 0m0 0H1.667M13 8h1.333M13 8a1.667 1.667 0 1 1-3.333 0M13 8a1.667 1.667 0 1 0-3.333 0m0 0h-8m6.666-5.333h6m-6 0a1.667 1.667 0 0 1-3.333 0m3.333 0a1.667 1.667 0 1 0-3.333 0m0 0H1.667"
    />
  </svg>
)
export default filter
